<div class="w-full flex flex-row items-start gap-x-4 rounded-md hover:bg-gray-100 dark:hover:bg-gray-800 p-2">
    <div class="shrink-0">
        <button (click)="expanded.set(!expanded())" type="button" class="fab-button-secondary-small text-secondary">
            @if (expanded()) {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path d="m6 9 6 6 6-6" />
            </svg>
            } @else {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path d="m9 18 6-6-6-6" />
            </svg>
            }
        </button>
    </div>

    <!-- Collapsed Content -->
    @if (!expanded()) {
    <div (click)="expanded.set(!expanded())" class="flex-1 flex flex-col gap-y-2 hover:cursor-pointer">
        <label for="ad-group-name-input" class="block text-md font-medium text-primary">
            Detailed Targeting
        </label>
        <ul role="list" class="flex flex-col gap-y-0 text-gray-600 dark:text-gray-400">
            <li class="inline-flex gap-x-3">
                <p class="text-sm text-primary font-semibold">Interests & Behaviours: </p>
                <p class="text-sm text-secondary">{{ smartInterestBehaviorSummaryLabel() }}</p>
            </li>
            <li class="inline-flex gap-x-3">
                <p class="text-sm text-primary font-semibold">Spending Power: </p>
                <p class="text-sm text-secondary">{{ spendingPowerSummaryLabel() }}</p>
            </li>
        </ul>
    </div>
    }
    <!-- Collapsed Content - END -->

    <!-- Opened Content -->
    @if (expanded()) {
    <div class="flex-1 flex flex-col gap-y-2">
        <label for="ad-group-name-input" class="block text-md font-medium text-primary">
            Detailed Targeting
        </label>

        <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">


            <!-- Interests & Behaviours -->
            <!-- <div class="sm:col-span-3">
                <p id="detailed-spending-power-label" class="block text-sm/6 font-medium text-gray-900 dark:text-white">
                    Interests & behaviors</p>
                <p id="detailed-spending-power-hint" class="text-xs text-gray-500 dark:text-gray-400">Target an audience
                    based on their long-term interests and interactions with content on TikTok.
                </p>
            </div> -->
            <!-- Interests & Behaviours - END -->

            <!-- Smart Interests & Behaviours -->
            <div class="sm:col-span-3 flex flex-row items-start gap-x-3">
                <div class="flex h-6 shrink-0 items-center">
                    <div class="group grid size-4 grid-cols-1">
                        <input id="detailed-smart-interest-behavior-checkbox" type="checkbox"
                            name="smartInterestBehavior"
                            aria-describedby="detailed-smart-interest-behavior-description"
                            [formControl]="smartInterestBehaviorControl"
                            class="col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-primary checked:bg-primary indeterminate:border-primary indeterminate:bg-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 dark:border-white/10 dark:bg-white/5 dark:checked:border-primary dark:checked:bg-primary dark:indeterminate:border-primary dark:indeterminate:bg-primary dark:focus-visible:outline-primary dark:disabled:border-white/5 dark:disabled:bg-white/10 dark:disabled:checked:bg-white/10 forced-colors:appearance-auto" />
                        <svg viewBox="0 0 14 14" fill="none"
                            class="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25 dark:group-has-disabled:stroke-white/25">
                            <path d="M3 8L6 11L11 3.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="opacity-0 group-has-checked:opacity-100" />
                            <path d="M3 7H11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="opacity-0 group-has-indeterminate:opacity-100" />
                        </svg>
                    </div>
                </div>
                <div class="">
                    <label for="detailed-smart-interest-behavior-checkbox"
                        class="block text-sm/6 font-medium text-gray-900 dark:text-white">Smart Interests & Behaviours</label>
                    <p id="detailed-smart-interest-behavior-description"
                        class="text-xs text-gray-500 dark:text-gray-400">Smart Targeting is an intelligent feature that helps you find the users most likely to complete your objective. When enabled, Smart Targeting will allow TikTok to deliver ads outside the designated Interest & Behaviors or Audience settings when it is likely to improve ad performance for the advertiser.
                    </p>
                </div>
            </div>
            <!-- Smart Interests & Behaviours - END -->


            <!-- Spending Power -->
            <div class="sm:col-span-3">
                <p id="detailed-spending-power-label" class="block text-sm/6 font-medium text-gray-900 dark:text-white">
                    Spending Power</p>
                <p id="detailed-spending-power-hint" class="text-xs text-gray-500 dark:text-gray-400">Spending power
                    relates to the degree to which people have money to buy products and services. High spending people
                    typically spend more on purchases than the average user.
                </p>
                <div class="mt-1 isolate flex w-full min-w-0 rounded-md shadow-xs dark:shadow-none" role="radiogroup"
                    aria-labelledby="detailed-spending-power-label" aria-describedby="detailed-spending-power-hint">
                    @for (opt of spendingPowerOptions; track opt.value) {
                    <button type="button" role="radio" [attr.aria-checked]="isSpendingPowerSelected(opt.value)"
                        (click)="selectSpendingPower(opt.value)" [class]="spendingPowerSegmentClass(opt.value, $index)">
                        {{ opt.label }}
                    </button>
                    }
                </div>
            </div>
            <!-- Spending Power - END -->
        </div>
    </div>
    }
</div>